export default {
  navHome: "首页",
  navProducts: "产品中心",
  navCases: "应用案例",
  navAbout: "关于咏远",
  deliverTo: "交货至:",
  langCurrencyLabel: "简体中文",
  localeLangTitle: "设置语言",
  localeLangDesc: "请选择您的首选语言。语言与网址将同步切换。",
  language: "语言",
  save: "保存",
  uiClose: "关闭",
  carouselPrev: "上一个产品",
  carouselNext: "下一个产品",
  heroSlidePrev: "上一张",
  heroSlideNext: "下一张",
  heroSlideDot: "切换到第{n}张",
  coreProducts: "助力现实世界创作",
  coreProductsDesc: "从创意到生意，YONGYUAN提供UV打印机、水晶标打印机、圆柱体高速打印机和DTF打印机、DTG打印机，将创意转化为产品、品牌和机遇。",
  scenariosTitle: "赋能每一个场景",
  scenariosDesc: "无论您是打造品牌、副业创收还是兴趣创作，YONGYUAN 总有一款解决方案能满足您的需求。",
  scenarioStudio: "工作室",
  scenarioStudioDesc: "高客单定制、小批量打样、打造品牌",
  scenarioRetail: "品牌门店",
  scenarioRetailDesc: "提升客户停留时长、增加门店营收",
  scenarioMarket: "集市摆摊",
  scenarioMarketDesc: "现场定制、销售成品、副业创收",
  scenarioEnterprise: "企业定制",
  scenarioEnterpriseDesc: "批量定制、品牌周边、商务礼品",
  scenarioEcommerce: "直播带货",
  scenarioEcommerceDesc: "爆款打样、柔性供货、快速上新",
  scenarioStore: "电商店铺",
  scenarioStoreDesc: "店铺定制、爆款周边、差异化经营",
  scenarioFactory: "工厂产线",
  scenarioFactoryDesc: "批量生产、稳定输出、降本增效",
  scenarioAdvertising: "广告制作",
  scenarioAdvertisingDesc: "标识标牌、展示物料、活动物料",
  industries: "行业应用",
  industriesDesc: "为不同行业的彩色印刷需求提供数字喷墨打印解决方案。",
  applicationsTitle: "解锁多元材质与色彩应用，满足日常与商业需求。",
  applicationsDesc: "YONGYUAN UV打印设备可适配多种材质与工艺场景，助力个性化定制与规模化生产。",
  casesHeroDesc: "覆盖1000+产品应用场景",
  casesBreadcrumbHome: "首页",
  casesBreadcrumbCenter: "应用场景",
  casesEmpty: "暂无该分类应用案例",
  customerStoriesTitle: "全球客户正在使用咏远品牌打印机创造价值",
  customerStoriesSubtitle: "来自172个国家客户的真实安装、培训与应用现场",
  customerStoriesTrustedTitle: "Trusted Worldwide",
  customerStoriesStat1Value: "53000+",
  customerStoriesStat1Label: "设备交付",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "服务国家",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "行业经验",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "技术支持",
  customerStoriesBadge: "已展示 {count} 张国外客户合照",
  customerStoriesPlaceholder: "放置客户合照",
  customerStoriesPhotoAlt: "YONGYUAN客户与打印机合影",
  customerStoryCountryUsaNewYork: "美国纽约",
  customerStoryCountryGermany: "德国",
  customerStoryCountryThailand: "泰国",
  customerStoryCountrySpain: "西班牙",
  customerStoryCountryBrazil: "巴西",
  customerStoryCountryAustralia: "澳洲",
  customerStoryCountrySaudiArabia: "沙特",
  customerStoryCountrySingapore: "新加坡",
  customerStoryCountryKorea: "韩国",
  customerStoryCountryIsrael: "以色列",
  customerStoryCountryKazakhstan: "哈萨克斯坦",
  customerStoryCountryMexico: "墨西哥",
  customerStoryCountryArgentina: "阿根廷",
  customerStoryCountryPhilippines: "菲律宾",
  customerStoryCountryIndonesia: "印尼",
  customerStoryCountryNetherlands: "荷兰",
  customerStoryCountrySweden: "瑞典",
  customerStoryCountrySouthAfrica: "南非",
  customerStoryCountryMalaysia: "马来西亚",
  customerStoryCountryTaiwan: "台湾",
  customerStoryCountryUsa: "美国",
  customerStoryCountryCambodia: "柬埔寨",
  customerStoryCountryCanada: "加拿大",
  customerStoryCaption01: "美国｜6090 UV Printer",
  customerStoryCaption02: "德国｜F33 DTF Printer",
  customerStoryCaption03: "泰国｜3250 UV Printer",
  customerStoryCaption04: "西班牙｜3250 UV Printer",
  customerStoryCaption05: "巴西｜2030 UV Printer",
  customerStoryCaption06: "澳洲｜F33 DTF Printer",
  customerStoryCaption07: "沙特｜2030 UV Printer",
  customerStoryCaption08: "新加坡｜F33 DTF Printer",
  customerStoryCaption09: "韩国｜F33 DTF Printer",
  customerStoryCaption10: "以色列｜UVC33 DTF Printer",
  customerStoryCaption11: "哈萨克斯坦｜4030 UV Printer",
  customerStoryCaption12: "墨西哥｜4060 UV Printer",
  customerStoryCaption13: "阿根廷｜4060 UV Printer",
  customerStoryCaption14: "菲律宾｜6090 UV Printer",
  customerStoryCaption15: "印尼｜4030 UV Printer",
  customerStoryCaption16: "荷兰｜4030 UV Printer",
  customerStoryCaption17: "瑞典｜4060 UV Printer",
  customerStoryCaption18: "德国｜2030 UV Printer",
  customerStoryCaption19: "南非｜2030 UV Printer",
  customerStoryCaption20: "马来西亚｜F33 DTF Printer",
  customerStoryCaption21: "中国台湾｜UVC33 DTF Printer",
  customerStoryCaption22: "美国｜F70Pro DTF Printer",
  customerStoryCaption23: "美国｜2513 UV Printer",
  customerStoryCaption24: "美国｜6090 UV Printer",
  customerStoryCaption25: "美国｜2030 UV Printer",
  customerStoryCaption26: "美国｜3250 UV Printer",
  customerStoryCaption27: "韩国｜4060 UV Printer",
  customerStoryCaption28: "荷兰｜4060 UV Printer",
  customerStoryCaption29: "柬埔寨｜4030 UV Printer",
  customerStoryCaption30: "加拿大｜F33 DTF Printer",
  servicePartnerTitle: "认识一下 YONGYUAN 服务团队，您的创意合作伙伴",
  servicePartnerDesc: "覆盖全球的服务网络与专业支持体系，为您的设备使用与业务增长保驾护航。",
  serviceSupportTitle: "标准支持",
  serviceSupportDesc: "提供安装指导、基础培训与日常使用答疑，保障设备稳定运行。",
  servicePresaleTitle: "售前演示与咨询",
  servicePresaleDesc: "根据您的应用场景与产能需求，提供方案演示与选型建议。",
  serviceLifetimeTitle: "终身技术支持",
  serviceLifetimeDesc: "持续的技术响应与工艺支持，陪伴您的业务长期发展。",
  serviceCareTitle: "升级至 YONGYUAN Care",
  serviceCareDamageTitle: "意外损坏保障",
  serviceCareDamageDesc: "为设备提供更全面的保障方案，降低突发风险带来的损失。",
  serviceCareExchangeTitle: "快速置换服务",
  serviceCareExchangeDesc: "在符合条件的情况下，优先安排快速置换，快速回笼资金。",
  viewProduct: "查看产品",
  learnMore: "了解更多",
  catUv: "UV打印机",
  catUvNav: "UV打印机",
  catCylinder: "圆柱体打印机",
  catCylinderNav: "圆柱体打印机",
  catCrystal: "水晶标打印机",
  catCrystalNav: "水晶标打印机",
  catDtf: "DTF打印机",
  catDtfNav: "DTF打印机",
  catDtg: "DTG打印机",
  catDtgNav: "DTG打印机",
  companyName: "深圳咏远科技有限公司",
  phone: "联系电话：17748697567 唐经理",
  email: "联系邮箱：sales@yongyuanprinter.com",
  copyright: "Copyright © 2012-2026 深圳咏远科技有限公司 版权所有",
  productsHeroTitle: "产品中心",
  productsHeroDesc: "覆盖UV平板、圆柱打印、UV DTF、水晶标、DTF及DTG全系列设备，满足个性化定制、批量生产与工业应用需求。",
  productsBreadcrumbHome: "首页",
  productsBreadcrumbCenter: "产品中心",
  productsEmpty: "该分类产品即将上线，敬请期待。",
  productsQuoteTitle: "获取方案与报价",
  productsQuoteDesc: "告诉我们您的应用场景与产能需求，我们将为您匹配合适的设备方案。",
  productsContact: "联系咨询",
  aboutHeroTitle: "关于咏远",
  aboutHeroDesc: "23年专注UV打印设备研发生产",
  productA23Subtitle: "小型桌面UV打印解决方案",
  productA23Industry: "适用场景：手机壳个性化定制｜钥匙扣徽章｜U盘名片小礼品｜打样与工作室创业｜等等",
  productA23Feature1: "20×30cm幅面",
  productA23Feature2: "6色精准打印",
  productA23Feature3: "红外自动测高",
  productA35Subtitle: "桌面级UV平板打印解决方案",
  productA35Industry: "适用场景：奖牌奖杯｜皮革卡包｜化妆品小盒｜亚克力摆件与纪念品｜等等",
  productA35Feature1: "32×50cm幅面",
  productA35Feature2: "6色智能墨路",
  productA35Feature3: "红外自动测高",
  productA43Subtitle: "商用A3幅面UV打印解决方案",
  productA43Industry: "适用场景：木板铭牌｜亚克力导视｜UV DTF转印膜｜小型包装与礼品打样｜等等",
  productA43Feature1: "40×30cm打印幅面",
  productA43Feature2: "8色可选方案",
  productA43Feature3: "多材质适配",
  productA46Subtitle: "商用A2幅面UV打印解决方案",
  productA46Industry: "适用场景：灯光画｜礼盒彩印｜玻璃工艺品｜文创周边小批量量产｜等等",
  productA46Feature1: "40×60cm打印幅面",
  productA46Feature2: "8色可选方案",
  productA46Feature3: "稳定量产输出",
  productA57Subtitle: "A2+幅面UV平板打印解决方案",
  productA57Industry: "适用场景：行李箱面板｜装饰画｜瓷砖画｜中型工艺品定制｜等等",
  productA57Feature1: "50×70cm幅面",
  productA57Feature2: "8色可选方案",
  productA57Feature3: "高精度细节还原",
  productA69Subtitle: "商用A1大幅面UV打印解决方案",
  productA69Industry: "适用场景：家具面板｜玻璃移门｜塑料/金属板材｜广告展板小批量｜等等",
  productA69Feature1: "60×90cm打印幅面",
  productA69Feature2: "8-15色可选方案",
  productA69Feature3: "工业级稳定输出",
  productA1216Subtitle: "超大幅面工业级UV打印解决方案",
  productA1216Industry: "适用场景：KT板展架｜门头招牌｜灯箱片｜商场导视与背景墙｜等等",
  productA1216Feature1: "120×160cm幅面",
  productA1216Feature2: "视觉定位系统",
  productA1216Feature3: "多喷头量产方案",
  productA2513Subtitle: "旗舰级工业UV平板打印解决方案",
  productA2513Industry: "适用场景：木门橱柜｜家居装饰板｜背景墙整板｜广告与家装批量生产｜等等",
  productA2513Feature1: "250×130cm幅面",
  productA2513Feature2: "视觉定位系统",
  productA2513Feature3: "连续批量生产",
  productA3220Subtitle: "超宽幅工业UV平板打印解决方案",
  productA3220Industry: "适用场景：岩板整板｜大型玻璃幕墙｜建筑装饰板｜高端整墙定制｜等等",
  productA3220Feature1: "320×200cm打印幅面",
  productA3220Feature2: "视觉定位系统",
  productA3220Feature3: "连续批量生产",
  productCylinderElfSubtitle: "高速圆柱体打印解决方案",
  productCylinderElfIndustry: "适用场景：保温杯环印｜酒瓶定制｜化妆品瓶｜杯壶礼品小批量｜等等",
  productCylinderElfFeature1: "360°环绕打印",
  productCylinderElfFeature2: "杯壶定制",
  productCylinderElfFeature3: "快速换治具",
  productCupPlusSubtitle: "多规格圆柱打印解决方案",
  productCupPlusIndustry: "适用场景：保温杯批量｜酒瓶/香水瓶｜企业礼品｜360°无缝环绕印刷｜等等",
  productCupPlusFeature1: "多规格治具",
  productCupPlusFeature2: "产线高效",
  productCupPlusFeature3: "稳定输出",
  productCrystal60Subtitle: "商业级水晶标打印解决方案",
  productCrystal60Industry: "适用场景：服装辅料标｜包装盒立体标｜玻璃金属转印标｜促销礼品标识｜等等",
  productCrystal60Feature1: "60cm幅宽",
  productCrystal60Feature2: "打印烫金一体",
  productCrystal60Feature3: "高效收料",
  productCrystal60UltraSubtitle: "旗舰级水晶标打印解决方案",
  productCrystal60UltraIndustry: "适用场景：品牌包装立体标｜烫金烫银标｜礼品深加工｜大批量连续转印｜等等",
  productCrystalC60UltraFeature1: "60cm幅宽",
  productCrystalC60UltraFeature2: "烫金烫银3D标",
  productCrystalC60UltraFeature3: "批量连续生产",
  productCrystal30Subtitle: "小型水晶标打印解决方案",
  productCrystal30Industry: "适用场景：手机壳转印标｜文创小标｜样标打样｜小批量多款定制｜等等",
  productCrystal30Feature1: "30cm幅宽",
  productCrystal30Feature2: "高精度标贴",
  productCrystal30Feature3: "操作便捷",
  productDtfF20Subtitle: "桌面型白墨烫画打印解决方案",
  productDtfF20Industry: "适用场景：个性T恤｜工作室创业｜小单快反｜帽衫卫衣烫画｜等等",
  productDtfF20Feature1: "A4打印尺寸",
  productDtfF20Feature2: "白墨彩图一体",
  productDtfF20Feature3: "智能墨路系统",
  productDtfF30Subtitle: "商用白墨烫画打印解决方案",
  productDtfF30Industry: "适用场景：服装定制店｜电商快反｜团队服｜文化衫短单｜等等",
  productDtfF30Feature1: "A3打印尺寸",
  productDtfF30Feature2: "单头手/自动可选",
  productDtfF30Feature3: "智能墨路系统",
  productDtfF30ProSubtitle: "高效白墨烫画打印解决方案",
  productDtfF30ProIndustry: "适用场景：服装加工厂｜批量热转印｜品牌代工｜门店连单生产｜等等",
  productDtfF30ProFeature1: "A3双喷头",
  productDtfF30ProFeature2: "自动收膜",
  productDtfF30ProFeature3: "智能墨路系统",
  productDtfF33Subtitle: "灵活配置白墨烫画解决方案",
  productDtfF33Industry: "适用场景：定制门店｜文创周边｜中小批量烫画｜多品类服装订单｜等等",
  productDtfF33Feature1: "A3打印尺寸",
  productDtfF33Feature2: "灵活工位配置",
  productDtfF33Feature3: "智能墨路系统",
  productDtfF70ProSubtitle: "工业级宽幅白墨烫画解决方案",
  productDtfF70ProIndustry: "适用场景：服装工厂产线｜大幅烫画｜批量订单｜连续收放料生产｜等等",
  productDtfF70ProFeature1: "70cm打印宽幅",
  productDtfF70ProFeature2: "2-4喷头可选",
  productDtfF70ProFeature3: "自动进出料续打",
  productDtf30Subtitle: "紧凑型白墨烫画设备",
  productDtf30Feature1: "小批量定制",
  productDtf30Feature2: "色彩还原好",
  productDtf30Feature3: "易于上手",
  productDtgPrintSubtitle: "数码直喷打印机",
  productDtgPrintFeature1: "多材质直喷",
  productDtgPrintFeature2: "高频生产",
  productDtgPrintFeature3: "稳定耐用",
  productDtg3250DSubtitle: "DTF&DTG二合一打印解决方案",
  productDtg3250DIndustry: "适用场景：服装综合门店｜DTF烫画+DTG直喷｜柔性接单｜一件起订｜等等",
  productDtg3250DFeature1: "A3+打印幅面",
  productDtg3250DFeature2: "DTF/DTG双模式",
  productDtg3250DFeature3: "智能墨路系统",
  productDtg3646TSubtitle: "双工位DTG直喷打印解决方案",
  productDtg3646TIndustry: "适用场景：T恤卫衣直喷｜批量文化衫｜直播电商供货｜双工位连续产出｜等等",
  productDtg3646TFeature1: "双工位连续生产",
  productDtg3646TFeature2: "效率提升100%",
  productDtg3646TFeature3: "智能墨路系统",
  productDtgMaxSubtitle: "工业级数码直喷机型",
  productDtgMaxFeature1: "工业级产能",
  productDtgMaxFeature2: "稳定耐用",
  productDtgMaxFeature3: "连续作业",
  app01Title: "手机壳",
  app02Title: "高尔夫球",
  app03Title: "石板画",
  app04Title: "圆珠笔",
  app05Title: "眼镜盒",
  app06Title: "木版画",
  app07Title: "易拉罐",
  app08Title: "键盘",
  app09Title: "保温杯",
  app10Title: "行李箱",
  app11Title: "亚克力",
  app12Title: "笔记本",
  app13Title: "徽章",
  app14Title: "皮质卡包",
  app15Title: "军牌",
  app16Title: "玻璃画",
  appDtgCase01: "T恤文化衫",
  appDtgCase02: "连帽卫衣",
  globeTapHint: "点选国家，查看服务覆盖",
  regionCn: "中国",
  regionUs: "美国",
  regionGb: "英国",
  regionDe: "德国",
  regionAe: "阿联酋",
  regionIn: "印度",
  regionJp: "日本",
  regionVn: "越南",
  regionBr: "巴西",
  regionAu: "澳大利亚",
  cityShanghai: "上海",
  cityShenzhen: "深圳",
  cityDetroit: "底特律",
  cityManchester: "曼彻斯特",
  cityStuttgart: "斯图加特",
  cityDubai: "迪拜",
  cityPune: "浦那",
  cityOsaka: "大阪",
  cityHoChiMinh: "胡志明市",
  citySaoPaulo: "圣保罗",
  cityMelbourne: "墨尔本",
  brandStatsTitle: "Trusted Worldwide",
  brandStat1Value: "53000+",
  brandStat1Label: "设备交付",
  brandStat2Value: "172+",
  brandStat2Label: "服务国家",
  brandStat3Value: "23+",
  brandStat3Label: "行业经验",
  brandStat4Value: "24/7",
  brandStat4Label: "技术支持"
};
